export const TWITTER_ACCOUNT_TOO_NEW =
  "Twitter account was created very recently";
export const VERY_FEW_FOLLOWERS = "Very few followers on social media";
export const ART_SAMPLES_DO_NOT_MATCH = "Art samples do not match social links";
export const ARTIST_NOT_APPLICANT =
  "I know the artist who made these works, and it's not the applicant";

export const OTHER_REASON_PREFIX = "OtherReason";
